module.exports = __webpack_public_path__ + "img/symbol_multi_solid.6fdd3620.png";